'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var Loader = require('../Loader/Loader.js');
var useTimeout = require('../../../hooks/useTimeout.js');
var cx = require('classnames');
var loader_module = require('../Loader/loader.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var ComponentLoader = function (_a) {
    var children = _a.children, className = _a.className, contentClassName = _a.contentClassName, textClassName = _a.textClassName, timeout = _a.timeout, timeoutCallback = _a.timeoutCallback, size = _a.size, rest = tslib.__rest(_a, ["children", "className", "contentClassName", "textClassName", "timeout", "timeoutCallback", "size"]);
    useTimeout.default(timeout, timeoutCallback);
    var displaySizeStyles = size ? ["".concat(loader_module.default[size])] : null;
    return (jsxRuntime.jsx("div", tslib.__assign({ className: cx__default.default('position-absolute', "".concat(loader_module.default['cover']), "".concat(loader_module.default['component-loader__overlay']), "".concat(loader_module.default['preloader']), className) }, rest, { children: jsxRuntime.jsxs("div", tslib.__assign({ className: cx__default.default("".concat(loader_module.default['loader__content']), contentClassName, {
                displaySizeStyles: displaySizeStyles,
                'bg-white': children
            }), "data-testid": "container" }, { children: [jsxRuntime.jsx(Loader.default, { className: "text-center", size: size }), children && (jsxRuntime.jsx("div", tslib.__assign({ className: cx__default.default('text-center pt-4', textClassName) }, { children: children })))] })) })));
};
var ComponentLoader$1 = ComponentLoader;

exports.default = ComponentLoader$1;
//# sourceMappingURL=ComponentLoader.js.map
